import React, { useState, FormEvent } from 'react'
import { useTranslation } from 'react-i18next'
import './PartnerSelect.css'
import { Partner } from '../store/store'
import { Modal, ModalBody, ModalFooter } from '../../../components/modal'

export type Props = {
  partners: Partner[]
  onCancel: () => void
  navigate: (url: string) => void
  partnerId?: string
}

function PartnerSelect(props: Props) {
  const { partners, partnerId, navigate, onCancel } = props
  const [selectedPartnerId, setSelectedPartnerId] = useState(partnerId)
  const { t } = useTranslation(['navigation','global'])

  function onChange(e: FormEvent<HTMLSelectElement>) {
    setSelectedPartnerId(e.currentTarget.value)
  }

  function onSelectPartner() {
    if (selectedPartnerId) {
      onCancel()
      navigate(`/partner/${selectedPartnerId}`)
    }
  }

  return (
    <Modal title={t('pick_a_partner')}>
      <ModalBody>
        <select id="partners" value={selectedPartnerId} onChange={onChange}>
          {partners.map((partner: Partner) => (
            <option key={partner.id} value={partner.id}>{partner.name}</option>
          ))}
        </select>
      </ModalBody>
      <ModalFooter>
        <button id="select-cancel" onClick={onCancel}>{t('global:cancel')}</button>
        <button id="select-partner" onClick={onSelectPartner}>{t('global:select')}</button>
      </ModalFooter>
    </Modal>
  )
}

export default PartnerSelect
